import { DeliveryProvider, OrderFulfillmentStatus, OrderMethod } from '../../../../../services/exports/Constants';

export default {
  text: {
    status: {
      [OrderFulfillmentStatus.Rejected]: 'Oletko varma?',
    },
    [OrderMethod.Pickup]: 'Onko asiakas jo noutanut tilauksen?',
    [OrderMethod.OnSite]: 'Onko tilaus tarjoiltu pöytään?',
    [OrderMethod.Delivery]: {
      [DeliveryProvider.Standalone]: 'Onko tilaus jo toimitettu?',
      [DeliveryProvider.UberDrive]: 'Onko kuljettaja jo noutanut tilauksen?',
      [DeliveryProvider.FirstDelivery]: 'Onko kuljettaja jo noutanut tilauksen?',
      [DeliveryProvider.WoltDrive]: 'Onko kuljettaja jo noutanut tilauksen?',
    },
  },
  buttons: {
    cancel: 'Ei, peruuta',
    confirm: 'Kyllä',
  },
};
